<template>
  <div class="all">
    <div class="news-right">
      <router-link
        v-if="$route.query.path"
        :to="{ path: `newscenter/` + $route.query.path }"
      >
        <h1>&lt; 返回</h1></router-link
      >
      <router-link
        v-if="!$route.query.path"
        replace
        :to="{ path: `/newscenter/newlist` }"
      >
        <h1>&lt; 返回</h1></router-link
      >
      <!-- <router-link path="{path:'/webindex'}"></router-link> -->
      <p class="line"></p>

      <div class="news">
        <div class="news-date">
          <div>
            <p>{{ this.day }}</p>
            <p>{{ this.year }}</p>
            <p></p>
          </div>
        </div>
        <div
          v-if="!title"
          class="loadingBox"
          v-loading="!title"
          element-loading-text="正在加载中"
        ></div>
        <div class="news-text">
          <h3>{{ this.title }}</h3>
          <div class=" ql-container ql-snow">
            <div class="ql-editor ql-snow" v-html="this.content"></div>
          </div>
        </div>
      </div>

      <!--  -->
      <div
        class="backTop"
        ref="backTop"
        @click="scrollToTop()"
        v-show="isVisible"
        id="scroll-to-top-button"
      >
        <i class="el-icon-top"></i>
      </div>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.snow.css";
export default {
  name: "newsdetailed",
  data() {
    return {
      resourId: this.$route.query.id,
      day: "",
      year: "",
      title: "",
      content: "",
      isVisible: false
    };
  },
  mounted() {
    this.selectById();
    // 组件销毁时移除滚动事件监听器
    window.removeEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.toggleVisibility);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.toggleVisibility);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    toggleVisibility() {
      this.isVisible = window.scrollY > 100; // 当页面滚动超过一定距离时显示按钮
    },

    selectById() {
      this.request.get(`/edit/${this.$route.query.id}`, {}).then(res => {
        this.day = res.data.data.createTime.slice(8, 10);
        this.year = res.data.data.createTime.slice(0, 7);
        this.title = res.data.data.title;
        this.content = res.data.data.content;

        console.log(
          this.day +
            "===" +
            this.year +
            "===" +
            this.title +
            "@@" +
            this.content
        );
      });
    }
  }
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 1200px) {
  body .news-right {
    margin-left: 0;
  }
}
/deep/ .ql-container.ql-snow {
  border: 0px;
}
.all {
  // width: 1180px;
  width: 1358px;
}
.center {
  width: 1560px;
  margin: 80px auto 0;
}
.news-text {
  // min-width: 926px;
  max-width: 926px;
}
.news-text h3 {
  text-align: center;
}
.content {
  width: 1215.9936px;
  height: 560.0064px;
}

.news-right {
  flex: 1;
  margin-left: 80px;
  min-height: 700px;
  position: relative;
}
.news-right h1 {
  display: inline-block;
  margin-bottom: 16.992px;
  font-size: 18px;
  color: #192147;
  line-height: 25px;
  letter-spacing: 1.92px;
}
.news-right .line {
  margin-bottom: 32.0064px;
  width: 100%;
  height: 1.9968px;
  background: #efeff2;
  opacity: 0.5;
}
.news {
  display: flex;
}
.news-right .news-date {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 132px;
  height: 170px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 42px;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(176, 183, 213, 0.2);
}
.news-date p:nth-child(1) {
  margin-bottom: 10.0032px;
  font-size: 36px;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 42px;
  letter-spacing: 1.92px;
}
.news-date p:nth-child(2) {
  margin-bottom: 2.9952px;
  font-size: 16px;
  font-weight: bold;
  color: #1d1d1d;
  opacity: 0.5;
  line-height: 19px;
  letter-spacing: 0.96px;
  white-space: nowrap;
}
.news-date p:nth-child(3) {
  width: 16.992px;
  height: 1.9968px;
  background: #ffa200;
}
.news .news-text h3 {
  margin-bottom: 18.0096px;
  font-size: 18px;
  font-weight: 400;
  color: #1d1e20;
  line-height: 24.9984px;
  letter-spacing: 0.96px;
}
.news .news-text p {
  font-size: 14px;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 27.9936px;
  letter-spacing: 0.9984px;
}
.loadingBox {
  width: 100%;
}

.backTop {
  position: fixed;
  bottom: 100px;
  right: 40px;
  font-size: 30px;
  background-color: #fff;
  border: 1px solid #192147;
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 50%;
  text-align: center;
  animation: showEl 0.3s;
}
@keyframes showEl {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 100px;
    opacity: 1;
  }
}
.backTop:hover {
  background-color: #0052d9;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/newsdetailed.vue